<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">02.A</span>
      <span class="section-title">Mandatory fields</span>
    </div>
    <span class="section-hint">Immutable after creation</span>
  </div>

  <div class="rules-table-wrapper">
    <div class="rules-table-header">
      <button class="rules-group-toggle">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
        </svg>
      </button>
      <span class="rules-group-name">POS Identity</span>
      <span class="rules-group-meta">{{ enabledFieldRuleCount }}/{{ fieldRules.length }} required</span>
    </div>

    <table class="rules-table">
      <thead>
        <tr>
          <th >FIELD</th>
          <th>CONDITIONAL LOGIC</th>
          <th>PRIORITY</th>
          <th>ACTIONS</th>
        </tr>
      </thead>
      <tbody>
        @for (rule of fieldRules; track rule.id) {
        <tr class="rule-row">
          <td>
            <div class="rule-field-cell">
              <button class="toggle-btn" [class.toggle-btn--on]="rule.enabled"
                (click)="toggleFieldRule(rule)" [title]="rule.enabled ? 'Disable' : 'Enable'">
                <span class="toggle-track">
                  <span class="toggle-thumb"></span>
                </span>
              </button>
              <span class="rule-field-name">{{ rule.fieldName }}</span>
            </div>
          </td>
          <td>
            <span class="rule-logic">
              @if (rule.alwaysRequired) {
                Always required
                @if (rule.conditionalLogic) { · {{ rule.conditionalLogic }} }
              } @else if (rule.conditionalLogic) {
                <span class="logic-pill">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M2 5h6M5 2v6" stroke="#f59e0b" stroke-width="1.3" stroke-linecap="round"/>
                  </svg>
                  {{ rule.conditionalLogic }}
                </span>
              } @else {
                —
              }
            </span>
          </td>
          <td>
            <span class="priority-badge">{{ rule.priority }}</span>
          </td>
          <td>
            <button class="remove-btn" (click)="removeFieldRule(rule.id)" title="Remove rule">
<h2 >...</h2>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>

    <!-- @if (showAddRuleForm) {
    <div class="inline-form">
      <div class="inline-form-row">
        <div class="form-group" style="flex:2">
          <label class="field-label">Field name</label>
          <input type="text" class="custom-input" [class.is-invalid]="newRuleError"
            [(ngModel)]="newRule.fieldName" placeholder="e.g. Owner email" autocomplete="off" />
          @if (newRuleError) { <div class="field-error">Field name is required</div> }
        </div>
        <div class="form-group" style="flex:1">
          <label class="field-label">Priority</label>
          <select class="custom-input" [(ngModel)]="newRule.priority">
            <option value="P0">P0 — Critical</option>
            <option value="P1">P1 — High</option>
            <option value="P2">P2 — Medium</option>
            <option value="P3">P3 — Low</option>
          </select>
        </div>
        <div class="form-group" style="flex:2">
          <label class="field-label">Conditional logic</label>
          <input type="text" class="custom-input"
            [(ngModel)]="newRule.conditionalLogic" placeholder="e.g. region = Dubai" autocomplete="off" />
        </div>
      </div>
      <div class="inline-form-footer">
        <label class="checkbox-label">
          <input type="checkbox" [(ngModel)]="newRule.alwaysRequired" />
          Always required
        </label>
        <div class="inline-form-actions">
          <button class="btn-discard" (click)="showAddRuleForm = false">Cancel</button>
          <button class="btn-create" (click)="addFieldRule()">Add rule</button>
        </div>
      </div>
    </div>
    } -->

    <!-- <button class="add-rule-btn" (click)="openAddRuleForm()">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M6 2v8M2 6h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
      Add field rule
    </button> -->
  </div>

  <div class="optional-section">
    <div class="optional-header" (click)="showOptionalFields = !showOptionalFields">
      <span class="optional-title">Optional fields</span>
      <span class="optional-count">9 optional</span>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
        [class.rotated]="showOptionalFields">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/>
      </svg>
    </div>
    @if (showOptionalFields) {
    <div class="optional-content">
      <div class="optional-group">
        <span class="optional-group-label">Operational details</span>
        <span class="optional-group-count">9 fields</span>
      </div>
    </div>
    }
  </div>
</div>

<div class="section-divider"></div>
